import React from 'react';
import { Link } from 'react-router-dom';
import heroImage from '../../assets/images/hero-image-vip-onboarding-medium-font2x.webp';

const LEAD_FORM = 'https://api.leadconnectorhq.com/widget/form/xSNa1tu0CCXyei8UJ2ew';

const HeroSection = () => (
  <section className="vipo-hero">
    <div className="vipo-hero__grid">
      {/* Left column — eyebrow + headline + subcopy + CTAs */}
      <div className="vipo-hero__left">
        {/* <p className="vipo-eyebrow">VIP Assisted Onboarding</p> */}

        <h1 className="vipo-hero__title">
          Everything to do anything rental.
        </h1>

        <p className="vipo-hero__tagline">All in one place. All included.</p>

        {/* Mobile-only: image sits right under the tagline. The desktop image
            lives in the right column (.vipo-hero__right) and is hidden here. */}
        <img
          src={heroImage}
          alt=""
          aria-hidden="true"
          className="vipo-hero__image vipo-hero__image--mobile"
        />

        <p className="vipo-hero__subcopy">
          Start renting vehicles fast. Go from onboard to on-rent in less than 60 minutes.
          Our dedicated VIP support team is ready to help you set up and get your vehicles rented.
        </p>

        <div className="vipo-hero__ctas">
          <Link
            to="https://app.rentid.io/sign-up"
            className="vipo-btn vipo-btn--primary"
          >
            Get started
          </Link>
          <a
            href={LEAD_FORM}
            target="_blank"
            rel="noopener noreferrer"
            className="vipo-btn vipo-btn--secondary"
          >
            Book Demo
          </a>
        </div>

        <p className="vipo-hero__note">
          <span className="vipo-hero__note-strong">ZERO onboarding fees</span> and a{' '}
          <span className="vipo-hero__note-strong">FREE website</span> until August 31st, 2026.
        </p>
      </div>

      {/* Right column — hero image */}
      <div className="vipo-hero__right">
        <img
          src={heroImage}
          alt="Integrated rental back office platform showing smart bookings, AI rental agents, insurance, and more"
          className="vipo-hero__image"
        />
      </div>
    </div>
  </section>
);

export default HeroSection;
